export const CANCEL = 'cancel';
export const CLOSE = 'close';
export const CLOSE_UPPER = 'Close';
export const BACK = 'back';
export const OK = 'ok';
export const OK_UPPER = 'OK';
export const SAVE = 'save';
export const SAVE_CHANGES = 'Save Changes';
export const DELETE = 'delete';
export const DELETE_UPPER = 'Delete';
export const CREATE = 'create';
export const ACCEPT = 'accept';
export const CONFIRM = 'confirm';
export const EDIT = 'edit';
export const ADDED = 'added';
export const EDITED = 'edited';
export const EDIT_UPPER = 'Edit';
export const OUTLINE = 'outline';
export const OUTLINED = 'outlined';
export const CONTAINED = 'contained';
export const DISABLED = 'disabled';
export const TEXT = 'text';
export const DEFAULT = 'default';
export const PRIMARY = 'primary';
export const FILLED = 'filled';
export const FILTER = 'filter';
export const SECONDARY = 'secondary';
export const INFO = 'info';
export const SUBMIT = 'submit';
export const SEND_EMAIL = 'send email';
export const BUTTON = 'button';
export const WARNING = 'warning';
export const SUCCESS = 'success';
export const YES = 'yes';
export const NO = 'no';
export const HOVER = 'hover';
export const RED = 'red';
export const SEND = 'send';
export const LOAD_MORE = 'load more';
export const ERROR = 'error';
export const INHERIT = 'inherit';
export const GENERATE = 'generate';
export const DOWNLOAD = 'download';
export const CONTINUE = 'continue';
export const SKIP = 'skip';
export const SKIP_STEP = 'Skip step';
export const SEE_ALL = 'See all';
export const COMPLETE = 'complete';
export const DONE = 'done';
export const STANDARD = 'standard';
export const VIEW_DETAILS = 'View details';
export const SEARCH = 'Search';
export const SEARCH_ITEM = 'Search item';
export const DETAILS = 'Details';
export const MARK_AS_PAID = 'Mark as Paid';
export const COLLECT_PAYMENT = 'Collect Payment';
export const SEND_PAYMENT_LINK = 'Send Payment Link';
export const ADD_PHONE_NUMBER = 'Add phone number';
export const MARK_ALL_AS_READ = 'Mark all as read';
export const VIEW_ALL_NOTIFICATIONS = 'View All Notifications';
export const CAPTURE_CREDIT_CARD_INFORMATION = 'Capture credit card information';
export const NEXT_TEXT = 'Next';
export const SEARCH_FOR_WINNER = 'Search for winner';
export const NOTIFY = 'Notify';
export const ADD_WINNER = 'Add Winner';
